import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u2g9n98tba: FaireBrandEntity = {
  token: "b_u2g9n98tba",
  type: "brand",
  name: "Goods for the Study",
  avatarUrl:
    "https://cdn.faire.com/fastly/11be35fcf2002c154c42c99ee54346f85a3771b8ef4338a6a2b48397772f44df.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a743fc5f01f7e53086e7f9cac5236566ed80cdde311eb64a0de935809a19731e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/11be35fcf2002c154c42c99ee54346f85a3771b8ef4338a6a2b48397772f44df.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a743fc5f01f7e53086e7f9cac5236566ed80cdde311eb64a0de935809a19731e.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Our first (of three) New York stationery stores opened in 2013, and now, twelve years later, we are designing and selling our own notebooks, pads, and cards, all of which are at least a little different than anything else on the market. Feedback is welcome, we are always evolving and trying to improve. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:19.400Z",
    importedBy: "entity-db-cli",
  },
};
